module.exports = __webpack_public_path__ + "static/media/kitchen-help.c619f74e.png";